import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { socket } from '../socket';
import { WsEvents } from '../events';
import {
  addTransferSuccess,
  deleteTransferSuccess,
  updateTransferSuccess,
} from '../../store/transfers/actions';
import { transfersEuropeApi } from '../../services/TransfersService';

export function useTransferOrders() {
  const dispatch = useDispatch();
  const activeQueryArgs = useSelector((state) => state.transfers.activeQueryArgs);
  const apiState = useSelector((state) => state[transfersEuropeApi.reducerPath]);
  /**
   * Add Event Hook
   */
  // useEffect(() => {
  //   function onAddEvent(res) {
  //     if ('error' in res) return;
  //     const newTransfer = res[0];  // Assuming res[0] is the transfer
  //     const newAgents = res[1];    // Optional: If you use agents elsewhere
  //     dispatch(
  //       transfersEuropeApi.util.updateQueryData('fetchAllTransfers', activeQueryArgs, (draft) => {
  //         draft.transfers.push(newTransfer);
  //         draft.agents = newAgents;
  //       })
  //     );
  //     // dispatch(addTransferSuccess(res));
  //   }
  //   socket.on(WsEvents.transfer.ON_ADDED, onAddEvent);

  //   return () => {
  //     socket.off(WsEvents.transfer.ON_ADDED, onAddEvent);
  //   };
  // }, [dispatch, activeQueryArgs]);

  /**
   * Update Event Hook
   */
  // useEffect(() => {
  //   function onUpdateEvent(res) {
  //     if ('error' in res) return;
  //     // const newTransfer = res[0][0];  // Assuming res[0] is the transfer
  //     // const newAgents = res[1];    // Optional: If you use agents elsewhere
  //     const [updatedTransfersOrOne, agents] = res;
  //     dispatch(
  //       transfersEuropeApi.util.updateQueryData('fetchAllTransfers', activeQueryArgs, (draft) => {
  //         const isBulk = Array.isArray(updatedTransfersOrOne);
  //         if (isBulk) {
  //           const updatesMap = updatedTransfersOrOne.reduce((map, transfer) => {
  //             map[transfer._id] = transfer;
  //             return map;
  //           }, {});

  //           draft.transfers = draft.transfers
  //             .map((transfer) =>
  //               updatesMap[transfer._id] ? { ...transfer, ...updatesMap[transfer._id] } : transfer
  //             )
  //             .filter((t) => !(t.completed === true || t.agentPaid === true));
  //         } else {
  //           const updatedItem = updatedTransfersOrOne;
  //           const index = draft.transfers.findIndex((t) => t._id === updatedItem._id);
  //           if (index !== -1) {
  //             draft.transfers[index] = {
  //               ...draft.transfers[index],
  //               ...updatedItem,
  //             };
  //           }
  //         }
  //         draft.agents = agents;
  //       })
  //     )
  //     // dispatch(
  //     //   transfersEuropeApi.util.updateQueryData('fetchAllTransfers', activeQueryArgs, (draft) => {
  //     //     const item = draft.transfers.find((row) => row._id === newTransfer._id);
  //     //     if (item) {
  //     //       Object.assign(item, newTransfer[0][0]); // Apply changes optimistically
  //     //     }
  //     //   })
  //     // );
  //     // dispatch(updateTransferSuccess(res));
  //   }
  //   socket.on(WsEvents.transfer.ON_UPDATED, onUpdateEvent);

  //   return () => {
  //     socket.off(WsEvents.transfer.ON_UPDATED, onUpdateEvent);
  //   };
  // }, [dispatch, activeQueryArgs]);


  // useEffect(() => {
  //   function onUpdateEvent(res) {
  //     if ('error' in res) return;
  //     dispatch(transfersEuropeApi.util.invalidateTags([{ type: 'transfers', id: 'LIST' }]));
  //   }
  //   socket.on(WsEvents.transfer.ON_UPDATED, onUpdateEvent);

  //   return () => {
  //     socket.off(WsEvents.transfer.ON_UPDATED, onUpdateEvent);
  //   };
  // }, [dispatch]);

//   useEffect(() => {
//     function onUpdateEvent(res) {
//       if ('error' in res) return;
// console.log(activeQueryArgs)
//       // 1) Patch visible caches immediately (optional but snappy)
//       for (const key of Object.keys(apiState.queries)) {
//         if (key.startsWith('fetchLatestTransfers(')) {
//           const args = JSON.parse(key.slice('fetchLatestTransfers('.length, -1));
//           dispatch(
//             transfersEuropeApi.util.updateQueryData('fetchLatestTransfers', args, (draft) => {
//               const idx = draft?.findIndex?.(t => t._id === res._id);
//               if (idx !== undefined && idx !== -1) draft[idx] = res;
//             })
//           );
//           // 2) Silent refresh without toggling fetching flags in the component
//           dispatch(transfersEuropeApi.util.prefetch('fetchLatestTransfers', args, { force: true }));
//         }

//         if (key.startsWith('filterTransfers(')) {
//           const args = JSON.parse(key.slice('filterTransfers('.length, -1));
//           dispatch(
//             transfersEuropeApi.util.updateQueryData('filterTransfers', args, (draft) => {
//               const idx = draft?.findIndex?.(t => t._id === res._id);
//               if (idx !== undefined && idx !== -1) draft[idx] = res;
//             })
//           );
//           dispatch(transfersEuropeApi.util.prefetch('filterTransfers', args, { force: true }));
//         }
//       }
//     }

//     socket.on(WsEvents.transfer.ON_UPDATED, onUpdateEvent);
//     return () => socket.off(WsEvents.transfer.ON_UPDATED, onUpdateEvent);
//   }, [dispatch]);
  /**
   * Delete Event Hook
   */
  // useEffect(() => {
  //   function onDeleteEvent(res) {
  //     if ('error' in res) return;      
  //     dispatch(
  //       transfersEuropeApi.util.updateQueryData('fetchAllTransfers', activeQueryArgs, (draft) => {
  //         if (!draft || !draft.transfers) return;
  //         const index = draft.transfers.findIndex((row) => row._id === res[0]._id);
  //         if (index !== -1) {
  //           draft.transfers.splice(index, 1); // Remove item optimistically
  //         }
  //       })
  //     );
  //     // dispatch(deleteTransferSuccess(res));
  //   }
  //   socket.on(WsEvents.transfer.ON_DELETED, onDeleteEvent);

  //   return () => {
  //     socket.off(WsEvents.transfer.ON_DELETED, onDeleteEvent);
  //   };
  // }, [dispatch, activeQueryArgs]);

  return null;
}
